import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorResolvedDataObjectFragment = { __typename: 'ConfiguratorDataObject', downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, originalFileName: string, mediaType?: string | null, width?: number | null, size?: any | null, imageTilesDescriptor?: { __typename: 'ConfiguratorImageTilesDescriptor', imageWidth: number, imageHeight: number, tileWidth: number, tileHeight: number, tileChannels?: number | null, tileMargin: number, tileMipLevels: number, tileMediaType: string, tileColorSpace: Types.ImageColorSpace, tileDownloadUrlPrefix: string, tileStorageFolderName: string } | null, related: Array<{ __typename: 'ConfiguratorRelatedDataObject', originalFileName: string, downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, mediaType?: string | null, width?: number | null, size?: any | null }> };

export type ConfiguratorResolveDataObjectsQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ConfiguratorResolveDataObjectsQuery = { __typename: 'Query', configuratorDataObjects: Array<{ __typename: 'ConfiguratorDataObject', downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, originalFileName: string, mediaType?: string | null, width?: number | null, size?: any | null, imageTilesDescriptor?: { __typename: 'ConfiguratorImageTilesDescriptor', imageWidth: number, imageHeight: number, tileWidth: number, tileHeight: number, tileChannels?: number | null, tileMargin: number, tileMipLevels: number, tileMediaType: string, tileColorSpace: Types.ImageColorSpace, tileDownloadUrlPrefix: string, tileStorageFolderName: string } | null, related: Array<{ __typename: 'ConfiguratorRelatedDataObject', originalFileName: string, downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, mediaType?: string | null, width?: number | null, size?: any | null }> }> };

export type ConfiguratorResolveDataObjectsLegacyQueryVariables = Types.Exact<{
  legacyIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorResolveDataObjectsLegacyQuery = { __typename: 'Query', configuratorDataObjects: Array<{ __typename: 'ConfiguratorDataObject', downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, originalFileName: string, mediaType?: string | null, width?: number | null, size?: any | null, imageTilesDescriptor?: { __typename: 'ConfiguratorImageTilesDescriptor', imageWidth: number, imageHeight: number, tileWidth: number, tileHeight: number, tileChannels?: number | null, tileMargin: number, tileMipLevels: number, tileMediaType: string, tileColorSpace: Types.ImageColorSpace, tileDownloadUrlPrefix: string, tileStorageFolderName: string } | null, related: Array<{ __typename: 'ConfiguratorRelatedDataObject', originalFileName: string, downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, mediaType?: string | null, width?: number | null, size?: any | null }> }> };

export const ConfiguratorResolvedDataObjectFragmentDoc = gql`
    fragment ConfiguratorResolvedDataObject on ConfiguratorDataObject {
  downloadUrl
  height
  id
  imageColorSpace
  legacyId
  originalFileName
  mediaType
  width
  size
  imageTilesDescriptor {
    imageWidth
    imageHeight
    tileWidth
    tileHeight
    tileChannels
    tileMargin
    tileMipLevels
    tileMediaType
    tileColorSpace
    tileDownloadUrlPrefix
    tileStorageFolderName
  }
  related {
    originalFileName
    downloadUrl
    height
    id
    imageColorSpace
    legacyId
    mediaType
    width
    size
  }
}
    `;
export const ConfiguratorResolveDataObjectsDocument = gql`
    query configuratorResolveDataObjects($ids: [ID!]) {
  configuratorDataObjects(ids: $ids) {
    ...ConfiguratorResolvedDataObject
  }
}
    ${ConfiguratorResolvedDataObjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveDataObjectsGQL extends Apollo.Query<ConfiguratorResolveDataObjectsQuery, ConfiguratorResolveDataObjectsQueryVariables> {
    override document = ConfiguratorResolveDataObjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorResolveDataObjectsLegacyDocument = gql`
    query configuratorResolveDataObjectsLegacy($legacyIds: [Int!]) {
  configuratorDataObjects(legacyIds: $legacyIds) {
    ...ConfiguratorResolvedDataObject
  }
}
    ${ConfiguratorResolvedDataObjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveDataObjectsLegacyGQL extends Apollo.Query<ConfiguratorResolveDataObjectsLegacyQuery, ConfiguratorResolveDataObjectsLegacyQueryVariables> {
    override document = ConfiguratorResolveDataObjectsLegacyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }